export default __webpack_public_path__ + "static/media/mariaFilo_logo.81305796.svg";